<template>
  <div class="buttonFixed">
    <b-dropdown toggle-class="text-decoration-none" variant="link" no-caret>
      <template v-slot:button-content>
        <div class="btn-circle btnpulse btn-addGroup">
          <svg xmlns="http://www.w3.org/2000/svg" width="24.375" height="29.969" viewBox="0 0 24.375 29.969">
            <g id="Icon_feather-file-plus" data-name="Icon feather-file-plus" transform="translate(-5 -2)">
              <path id="Path_10166" data-name="Path 10166" d="M19.984,3H8.8A2.8,2.8,0,0,0,6,5.8V28.172a2.8,2.8,0,0,0,2.8,2.8H25.578a2.8,2.8,0,0,0,2.8-2.8V11.391Z" fill="none" stroke="#333" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
              <path id="Path_10167" data-name="Path 10167" d="M21,3v8.391h8.391" transform="translate(-1.016)" fill="none" stroke="#333" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
              <path id="Path_10168" data-name="Path 10168" d="M18,26.391V18" transform="translate(-0.813 -1.016)" fill="none" stroke="#333" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
              <path id="Path_10169" data-name="Path 10169" d="M13.5,22.5h8.391" transform="translate(-0.508 -1.32)" fill="none" stroke="#333" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            </g>
          </svg>
        </div>
      </template>
      <b-dropdown-item @click="showModalAddFolder">
        <div class="icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="28.948" height="26.253" viewBox="0 0 28.948 26.253">
            <g id="Icon_feather-folder-plus" data-name="Icon feather-folder-plus" transform="translate(-2 -3.5)">
              <path id="Path_10161" data-name="Path 10161" d="M29.948,26.058a2.7,2.7,0,0,1-2.695,2.695H5.695A2.7,2.7,0,0,1,3,26.058V7.195A2.7,2.7,0,0,1,5.695,4.5h6.737l2.695,4.042H27.253a2.7,2.7,0,0,1,2.695,2.695Z" fill="none" stroke="#333" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
              <path id="Path_10162" data-name="Path 10162" d="M18,16.5v8.084" transform="translate(-1.526 -1.221)" fill="none" stroke="#333" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
              <path id="Path_10163" data-name="Path 10163" d="M13.5,21h8.084" transform="translate(-1.068 -1.679)" fill="none" stroke="#333" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            </g>
          </svg>
        </div>
        <span class="text">フォルダ追加</span>
      </b-dropdown-item>
      <b-dropdown-item @click="showModalAddFiles">
        <div class="icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="24.375" height="29.969" viewBox="0 0 24.375 29.969">
            <g id="Icon_feather-file-plus" data-name="Icon feather-file-plus" transform="translate(-5 -2)">
              <path id="Path_10166" data-name="Path 10166" d="M19.984,3H8.8A2.8,2.8,0,0,0,6,5.8V28.172a2.8,2.8,0,0,0,2.8,2.8H25.578a2.8,2.8,0,0,0,2.8-2.8V11.391Z" fill="none" stroke="#333" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
              <path id="Path_10167" data-name="Path 10167" d="M21,3v8.391h8.391" transform="translate(-1.016)" fill="none" stroke="#333" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
              <path id="Path_10168" data-name="Path 10168" d="M18,26.391V18" transform="translate(-0.813 -1.016)" fill="none" stroke="#333" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
              <path id="Path_10169" data-name="Path 10169" d="M13.5,22.5h8.391" transform="translate(-0.508 -1.32)" fill="none" stroke="#333" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            </g>
          </svg>
        </div>
        <span class="text">ファイル追加</span>
      </b-dropdown-item>
      <b-dropdown-item @click="showModalMergeVideos">
        <div class="icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="24.375" height="29.969" viewBox="0 0 24.375 29.969">
            <g id="Icon_feather-file-plus" data-name="Icon feather-file-plus" transform="translate(-5 -2)">
              <path id="Path_10166" data-name="Path 10166" d="M19.984,3H8.8A2.8,2.8,0,0,0,6,5.8V28.172a2.8,2.8,0,0,0,2.8,2.8H25.578a2.8,2.8,0,0,0,2.8-2.8V11.391Z" fill="none" stroke="#333" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
              <path id="Path_10167" data-name="Path 10167" d="M21,3v8.391h8.391" transform="translate(-1.016)" fill="none" stroke="#333" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
              <path id="Path_10168" data-name="Path 10168" d="M18,26.391V18" transform="translate(-0.813 -1.016)" fill="none" stroke="#333" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
              <path id="Path_10169" data-name="Path 10169" d="M13.5,22.5h8.391" transform="translate(-0.508 -1.32)" fill="none" stroke="#333" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            </g>
          </svg>
        </div>
        <span class="text">動画を統合する</span>
      </b-dropdown-item>
    </b-dropdown>
    <ModalFolderAdd />
    <ModalFileAdd />
    <ModalMergeVideo />
  </div>

</template>

<script>
import ModalFolderAdd from '@/components/Admin/FolderManagerment/FolderAdd'
import ModalFileAdd from '@/components/Admin/FolderManagerment/AddFile'
import ModalMergeVideo from '@/components/Admin/FolderManagerment/MergeVideo'
export default {
  name: 'BtnGroupAdd',
  components: {
    ModalFolderAdd,
    ModalFileAdd,
    ModalMergeVideo
  },
  data () {
    return {
      modalShow: false
    }
  },
  methods: {
    showModalAddFiles () {
      this.$store.dispatch('adminFolder/getTag', {company_id: this.$route.params.id})
      this.$root.$emit('bv::show::modal', 'modalAddFiles', '#modalAddFiles')
    },
    showModalAddFolder () {
      this.$root.$emit('bv::show::modal', 'modalAddFolder', '#modalAddFolder')
    },
    showModalMergeVideos () {
      this.$bvModal.show('modalVideoMerge')
    }
  }
}
</script>
<style scoped lang="scss">
  @import "@/assets/stylesheet/auth/breadcrumb.scss";
</style>



// WEBPACK FOOTER //
// src/components/Admin/FolderManagerment/BtnGroupAdd.vue